/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import makeRequest from 'utils/makeRequest';
import LoaderSpinner from 'components_v2/common/LoaderSpinner';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import s from './RHSRelatedVideos.scss';
import VideoWidget from '../VideoWidget/VideoWidget';

const RHSRelatedVideos = props => {
  const [tabs, setTabs] = useState([]);
  const [videoList, setVideoList] = useState([]);
  const [loader, setloader] = useState(false);

  const ssrVideosList =
    props.item && Array.isArray(props.item.items)
      ? props.item.items
      : undefined;

  const request = async dataUrl => {
    try {
      if (dataUrl.includes('feed_rhs_videos')) {
        dataUrl += `?msid=${props.msid}`;
      }
      setloader(true);
      const data = await makeRequest.get(
        dataUrl,
        { isMobile: props.isMobile },
        'skipfeedengine',
      );
      setloader(false);
      if (data?.data?.items?.length > 0) {
        return data.data;
      }
      return null;
    } catch (e) {
      setloader(false);
      return null;
    }
  };

  const fetchSectionData = async (dataUrl, i, nav) => {
    const data = await request(dataUrl);
    if (data?.items?.length) {
      if (nav && nav[i] && data.name !== nav[i].name) {
        const temp = [...nav];
        temp[i].name = data.name;
        nav = temp;
      }
      if (nav?.length) {
        setTabs(nav);
      }
      setVideoList([...data.items]);
    }
  };

  const fetchNavigation = async dataUrl => {
    const data = await request(dataUrl);
    if (data?.items?.length) {
      fetchSectionData(data.items[0].dataUrl, 0, [...data.items]);
    }
  };

  useEffect(() => {
    if (!ssrVideosList && !videoList?.length && props.item.dataUrl) {
      fetchNavigation(props.item.dataUrl);
    }
  }, []);

  const loadAjaxSectionData = (data, i) => {
    fetchSectionData(data.clickedItem.dataUrl, i);
  };
  const playerConfig = {
    isMute: true,
    playOnLoad: false,
    videoClassName: s.video_class,
    adSection: props.isRHSWidgetAS ? 'scroll' : '',
  };
  if (
    props.isNavigationAbsent &&
    !(Array.isArray(ssrVideosList) && ssrVideosList.length)
  ) {
    return null;
  }
  if (Array.isArray(ssrVideosList) && ssrVideosList.length) {
    return (
      <div className="relatedVideoWrapper">
        <VideoWidget
          playerConfig={playerConfig}
          isRhsVideo
          // styles={s}
          sectionData={{
            ...props.item,
            navigation: tabs,
            items: ssrVideosList,
          }}
          viewMore
          loadAjaxSectionData={(d, i) => loadAjaxSectionData(d, i)}
          isRHSWidgetAS={props.isRHSWidgetAS}
          isRHSWidgetLB={props.isRHSWidgetLB}
          isRHSWidgetPS={props.isRHSWidgetPS}
          isNavigationAbsent={props.isNavigationAbsent}
          enableSlider
          isServerSideRendered
          subSecSeoLocation={props.subSecSeoLocation}
          isFromEtimesAS={props.isEtimes}
        />
      </div>
    );
  }
  return (
    <>
      {videoList.length > 0 ? (
        <div className="relatedVideoWrapper">
          <VideoWidget
            playerConfig={playerConfig}
            isRhsVideo
            // styles={s}
            sectionData={{
              ...props.item,
              navigation: tabs,
              items: videoList,
            }}
            viewMore
            loadAjaxSectionData={(d, i) => loadAjaxSectionData(d, i)}
            isRHSWidgetAS={props.isRHSWidgetAS}
            isRHSWidgetLB={props.isRHSWidgetLB}
            isRHSWidgetPS={props.isRHSWidgetPS}
          />
          {loader && (
            <div className={s.loader}>
              <LoaderSpinner />
            </div>
          )}
        </div>
      ) : null}
    </>
  );
};

RHSRelatedVideos.propTypes = {
  msid: PropTypes.string,
  item: PropTypes.shape({
    id: PropTypes.string,
  }),
  dataUrl: PropTypes.string,
  // rhsWidgetVideoAS: PropTypes.bool,
  isRHSWidgetAS: PropTypes.bool,
  isRHSWidgetLB: PropTypes.bool,
  isRHSWidgetPS: PropTypes.bool,
  isMobile: PropTypes.bool,
  isNavigationAbsent: PropTypes.bool,
  subSecSeoLocation: PropTypes.string,
  isEtimes: PropTypes.bool,
};
RHSRelatedVideos.defaultProps = {
  msid: '',
  item: {
    id: '',
  },
  dataUrl: '',
  // rhsWidgetVideoAS: true,
  isRHSWidgetAS: false,
  isRHSWidgetLB: false,
  isRHSWidgetPS: false,
  isMobile: false,
  isNavigationAbsent: false,
  subSecSeoLocation: '',
  isEtimes: false,
};

const mapStateToProps = state => ({
  msid: state?.liveblog_v2?.timelineData?.msid,
  isMobile: state.isMobile,
});
export default connect(mapStateToProps)(RHSRelatedVideos);
